<div class="navbar-header">
  <div class="navbar-brand dropdown" [class.open]="menuOpen">
    <a
      id="dropdown-toggle"
      href="#"
      role="button"
      draggable="false"
      [cdkMenuTriggerFor]="menu"
      [class.dropdown-toggle]="navbar.brandOptions!.length > 0"
      (cdkMenuClosed)="menuOpen = false"
      (cdkMenuOpened)="menuOpen = true"
      (click)="$event.preventDefault()"
    >
      <ng-content />
      <span class="caret"></span>
    </a>
  </div>
</div>

<ng-template #menu>
  <ul class="dropdown-menu tw:block tw:top-0 tw:w-auto tw:p-0 tw:mt-0 tw:static tw:overflow-y-auto" cdkMenu>
    @for (brandOption of navbar.brandOptions; track brandOption) {
      <li class="tw:overflow-visible" role="none">
        <a
          class="cdk-menu-item tw:px-4 tw:min-h-16 tw:inline-flex tw:items-center tw:min-w-75 tw:border-t tw:border-[#dadada]"
          cdkMenuItem
          [attr.aria-current]="brandOption.active"
          [attr.aria-label]="brandOption.label"
          [attr.href]="brandOption.href"
          [class.active]="brandOption.active"
          (click)="brandOption.click.emit($event)"
        >
          <ng-template [ngTemplateOutlet]="brandOption.content" />
        </a>
      </li>
    }
  </ul>
</ng-template>
